export const SPOLIGHT_SCREEN_NAME = 'proformaRtcEmptyStateChangeboardingSpotlight';
export const SPOTLIGHT_ID = 'proforma-rtc-empty-state-changeboarding-spotlight';
export const SPOTLIGHT_TARGET_ID = 'proforma-rtc-empty-state-changeboarding-spotlight-target';
